export const NAV_BUTTON_OUTER_PADDING_X = 2;
export const NAV_MAIN_BUTTON_SIDE_PADDING = 2;
export const NAV_DRAWER_PANEL_PADDING_X = NAV_BUTTON_OUTER_PADDING_X;
export const NAV_DRAWER_PANEL_PADDING_X_COLLAPSED = 0;
export const NAV_SIDEBAR_EXPANDED_WIDTH = 200;
export const NAV_SIDEBAR_COLLAPSED_WIDTH = 65;
export const MOBILE_NAV_PRIMARY_HEIGHT = 64;
export const MOBILE_NAV_SECONDARY_HEIGHT = 48;
export const MOBILE_NAV_SAFE_GAP = 16;

// Shared between the drawer content list (desktop + mobile drawer) and the
// mobile bottom subnav.
export const NAV_SUB_FONT_SIZE = '0.8rem';

// App shell header heights. Keep in sync with the literals in
// layoutFallback.css and the theme layout policies in themes/.
export const HEADER_HEIGHT_DESKTOP = 80;
export const HEADER_HEIGHT_MOBILE = 60;

// Reuse the combined inset so the header toggle lines up with the drawer buttons.
export const NAV_DRAWER_SECTION_BUTTON_GUTTER = NAV_DRAWER_PANEL_PADDING_X + NAV_BUTTON_OUTER_PADDING_X;
